import React, { useEffect, useState } from "react";
import bgImg from "../../assets/bg_img.jpg";
import reject from "../../assets/reject.svg";
import gif from "../../assets/cardGif.gif";
import { Row, Col, Input, Button, Typography, message } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import arrowleft from "../../assets/back-arrow.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { useAllProduct } from "../../components/api-context/commonApiContext";
import Config from "../../config/Config";

const { Title, Text } = Typography;

const Kyc = () => {
  const { merchantInfo, phoneNo } = useAllProduct();
  const [aadhar, setAadhar] = useState("");
  // const [pan, setPan] = useState("");
  const [kycSubmitted, setKycSubmitted] = useState(false);
  const [kycRejected, setKycRejected] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  // const handleSubmit = async () => {
  //   setErrorMsg("");
  //   if (!aadhar || !pan) {
  //     setErrorMsg("Please enter both Aadhar and PAN number");
  //     return;
  //   }

  //   // Basic validation
  //   if (aadhar.length !== 12 || !/^\d+$/.test(aadhar)) {
  //     setErrorMsg("Please enter a valid 12-digit Aadhar number");
  //     return;
  //   }
  //   if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan.toUpperCase())) {
  //     setErrorMsg("Please enter a valid PAN number");
  //     return;
  //   }

  //   if (!merchantInfo.merchant_id) {
  //     setErrorMsg("merchant ID not found. Please sign up again.");
  //     navigate("/sign-up");
  //     return;
  //   }

  //   try {
  //     const response = await fetch(`${Config.node_api_endpoint}/kyc-details`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         "X-API-Key": process.env.REACT_APP_API_KEY,
  //       },
  //       body: JSON.stringify({
  //         merchant_id: merchantInfo.merchant_id,
  //         aadhar_no: aadhar,
  //         pan_no: pan.toUpperCase(),
  //       }),
  //     });

  //     const result = await response.json();
  //     if (result.success) {
  //       message.success("KYC details submitted successfully!");
  //       setKycSubmitted(true);
  //     } else {
  //       setKycRejected(true);
  //       setErrorMsg(result.message || "KYC submission failed.");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     setErrorMsg("Something went wrong. Please try again.");
  //   }

  //   // Wait 8 seconds, then navigate
  //   setTimeout(() => {
  //     navigate("/load-money");
  //   }, 8000);
  // };
  useEffect(() => {
    if (!merchantInfo?.merchant_id) return;

    const fetchUserStatus = async () => {
      try {
        const response = await fetch(
          `${Config.node_api_endpoint}/get-user-status`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-Key": process.env.REACT_APP_API_KEY,
            },
            body: JSON.stringify({ payment_id: merchantInfo.payment_id }),
          }
        );
        const result = await response.json();
        if (result.success) {
          if(result.data.kyc_status === "completed"){
            navigate("/load-money")
          } 
        } else {
          console.warn("⚠️ Failed to fetch user:", result.message);
        }
      } catch (err) {
        console.error("❌ Error fetching user status:", err);
      }
    };

    fetchUserStatus();
  }, [merchantInfo, navigate]);

  const handleSubmit = async () => {
    setErrorMsg("");

    if (!aadhar) {
      setErrorMsg("Please enter both Aadhar");
      return;
    }

    // Aadhaar & PAN validations
    if (aadhar.length !== 12 || !/^\d+$/.test(aadhar)) {
      setErrorMsg("Invalid Aadhaar number");
      return;
    }
    // if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan.toUpperCase())) {
    //   setErrorMsg("Invalid PAN format");
    //   return;
    // }

    try {
      const response = await fetch(
        `${Config.node_api_endpoint}/generate-kyc-link`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": process.env.REACT_APP_API_KEY,
          },
          body: JSON.stringify({
            phone_number: phoneNo,
            // phone_number: "8220462971",
            aadhar_no: aadhar,
            // pan_no: pan,
            merchant_id: merchantInfo.merchant_id,
            payment_id: merchantInfo.payment_id,
          }),
        }
      );

      const result = await response.json();
      console.log("KYC Result =>", result);

      if (!result.success || !result.digilocker_link) {
        setErrorMsg("KYC service failed. Try again.");
        return;
      }

      // ✅ Redirect to Digilocker SDK directly
      window.location.href = result.digilocker_link;
    } catch (err) {
      console.error("Error generating KYC link:", err);
      setErrorMsg("Something went wrong. Try again.");
    }
  };

  const handleRetry = async () => {
    setKycRejected(false);
  };

  const goBack = () => {
    navigate("/sign-up");
  };
  console.log("mobile", phoneNo);

  return (
    <div
      style={{
        backgroundImage: `url(${bgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        height: "80vh",
        width: "100vw",
        position: "relative",
        color: "#fff",
        padding: "50px 20px 100px",
      }}
    >
      <div style={{ position: "absolute", inset: 0, zIndex: 0 }} />
      <Row
        justify="center"
        style={{
          position: "relative",
          zIndex: 2, // keep content above overlay
          width: "100%",
          maxWidth: 420,
          margin: "0 auto",
        }}
      >
        <Col span={24}>
          {/* Header */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: 20,
              height: 40,
            }}
          >
            <img
              src={arrowleft}
              style={{ cursor: "pointer" }}
              alt="Back"
              onClick={() => goBack()}
            />

            <Title
              level={4}
              style={{
                color: "#333333",
                margin: 0,
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                // width: "100%",
                textAlign: "center",
              }}
            >
              Complete Your KYC
            </Title>
          </div>

          <Text style={{ color: "#fff", fontWeight: 700, fontSize: "18px" }}>
            <span style={{ color: "#333333" }}>Welcome to </span>{" "}
            <span style={{ color: "#2348AB" }}>Khazana Card</span>
          </Text>

          {!kycRejected ? (
            <>
              {" "}
              <Title
                level={5}
                style={{ color: "#333333", marginTop: 20, marginBottom: 10 }}
              >
                {!kycSubmitted
                  ? "Complete your KYC"
                  : "Your KYC verification is in progress."}
              </Title>
              {!kycSubmitted ? (
                <Text
                  style={{ color: "#bbb", display: "block", marginBottom: 30 }}
                >
                  Enter your
                  <b style={{ color: "#333333", fontWeight: "600" }}>
                    &nbsp; Aadhaar
                  </b>
                  &nbsp; to verify your profile.
                </Text>
              ) : (
                <Text
                  style={{ color: "#bbb", display: "block", marginBottom: 30 }}
                >
                  Please wait while we verify your
                  <b style={{ color: "#333333", fontWeight: "600" }}>
                    &nbsp; Aadhaar
                  </b>
                  .
                </Text>
              )}
              {!kycSubmitted ? (
                <>
                  <Text
                    style={{ color: "#333333", fontSize: 14, fontWeight: 600 }}
                  >
                    Aadhaar Number
                  </Text>
                  <Input
                    inputMode="numeric"
                    maxLength={12}
                    placeholder="Enter Aadhar number"
                    size="large"
                    value={aadhar}
                    onChange={(e) => {
                      setAadhar(e.target.value);
                      setErrorMsg(""); // clear inline error
                    }}
                    style={{
                      borderRadius: 4,
                      marginTop: 8,
                      marginBottom: 20,
                      border: "1px solid #777777",
                    }}
                  />

                  {/* <Text
                    style={{ color: "#333333", fontSize: 14, fontWeight: 600 }}
                  >
                    PAN Number
                  </Text>
                  <Input
                    maxLength={10}
                    placeholder="Enter PAN number"
                    size="large"
                    value={pan}
                    onChange={(e) => {
                      setPan(e.target.value.toUpperCase());
                      setErrorMsg("");
                    }}
                    style={{
                      borderRadius: 4,
                      marginTop: 8,
                      marginBottom: 20,
                      border: "1px solid #777777",
                    }}
                  /> */}
                  {errorMsg && (
                    <div
                      style={{ color: "red", fontSize: 13, marginBottom: 10 }}
                    >
                      {errorMsg}
                    </div>
                  )}
                </>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <img src={gif} alt="Processing" width="150" height="150" />
                </div>
              )}
              <Button
                type="primary"
                block
                size="large"
                onClick={handleSubmit}
                style={{
                  backgroundColor: "#2348AB",
                  borderRadius: 10,
                  border: "none",
                  boxShadow: "0 0 15px rgba(35,72,171,0.6)",
                  fontWeight: 600,
                  marginTop: 10,
                }}
              >
                {kycSubmitted ? "Go Back" : "Proceed to KYC"}
              </Button>
            </>
          ) : (
            <>
              <Text
                style={{ color: "#bbb", display: "block", marginBottom: 30 }}
              >
                Your KYC verification has been rejected.
              </Text>
              <Text
                style={{ color: "#9E9EA0", display: "block", marginBottom: 30 }}
              >
                Please re-submit your details.
              </Text>
              <div className="d-flex justify-content-center mb-4">
                <img src={reject} />
              </div>
              <div className="d-flex gap-2">
                <Button
                  type="primary"
                  block
                  size="large"
                  // onClick={handleSubmit}
                  style={{
                    backgroundColor: "#ffff",
                    color: "#2348AB",
                    border: "2px solid #2348AB",
                    borderRadius: 10,
                    fontWeight: 600,
                    marginTop: 10,
                  }}
                >
                  {"Go Back"}
                </Button>
                <Button
                  type="primary"
                  block
                  size="large"
                  onClick={handleRetry}
                  style={{
                    backgroundColor: "#2348AB",
                    borderRadius: 10,
                    border: "none",
                    fontWeight: 600,
                    marginTop: 10,
                  }}
                >
                  {"Retry"}
                </Button>
              </div>
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Kyc;
